import { useTranslation } from "react-i18next";
import PiDeleteButton from "../../../components/PiDeleteButton";
import NodeStringDropdown from "../components/NodeStringDropdown";
import NodeActorDropdown from "../components/NodeActorDropdown";
import LookatTargetDropdown from "./LookatTargetDropdown";
import { hasLookatTarget } from "../../../models/NoLookat";

export default function LookatEntryCard(props: {
  nodeId: string;
  index: number;
  total: number;
  hasErrors?: boolean;
  sourceNpcId: string;
  targetId: string;
  /** Head only (FinalIK); missing/false = whole body. */
  finalIK?: boolean;
  onActorChange: (sourceNpcId: string) => void;
  onTargetChange: (targetId: string) => void;
  onLookModeChange: (finalIK: boolean) => void;
  onDelete: () => void;
}) {
  const { t } = useTranslation();
  const indexLabel = String(props.index + 1).padStart(2, "0");
  const wholeBodyLabel = String(t("look_mode.whole_body"));
  const headOnlyLabel = String(t("look_mode.head_only"));

  return (
    <div
      // No box per entry: entries sit open in the node, split by a hairline (errors keep a soft red wash).
      className={`w-full ${props.index > 0 ? "border-t border-solid border-creator-border pt-[12px]" : ""} ${
        props.hasErrors ? "rounded-[6px] bg-creator-error-washed px-[8px] pb-[8px]" : ""
      }`}
      onScroll={(e) => e.stopPropagation()}
    >
      <div className="w-full flex items-center justify-between h-[20px] mb-[10px]">
        <div className="text-[12px] font-semibold text-creator-text-sub">
          Lookat {indexLabel}
        </div>
        {props.total > 1 && (
          <div className="h-[20px] w-[20px] shrink-0">
            <PiDeleteButton onClick={props.onDelete} size="small" />
          </div>
        )}
      </div>
      <div className="w-full flex flex-col gap-[12px]">
        <NodeActorDropdown
          label="Actor"
          selectedActorId={props.sourceNpcId}
          onClick={props.onActorChange}
        />
        <LookatTargetDropdown
          label="Target"
          nodeId={props.nodeId}
          targetIndex={props.index}
          selectedTargetId={props.targetId}
          onClick={props.onTargetChange}
          excludeActorId={props.sourceNpcId}
          allowNoActor
        />
        {/* how to look, once there is something to look at (same as the bubble nodes) */}
        {hasLookatTarget(props.targetId) && (
          <NodeStringDropdown
            label={String(t("look_mode.label"))}
            items={[wholeBodyLabel, headOnlyLabel]}
            selectedItem={props.finalIK ? headOnlyLabel : wholeBodyLabel}
            onClick={(item: string) => props.onLookModeChange(item === headOnlyLabel)}
          />
        )}
      </div>
    </div>
  );
}
